const defaultState = {
  myConn: null,
  local: null,
  clients: {},
  clientStates: {}, // videoMute, audioMute
  currentUserState: { videoMute: false, audioMute: false }
};

const streaming = (state = defaultState, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'INITIAL_STREAMING_STATE':
      return defaultState;

    case 'UPDATE_STREAMING':
      return { ...state, ...payload };

    case 'LOGOUT':
      return {};

    default:
      return state;
  }
};

export default streaming;
